<template>
  <transition name="custom-loading-fade">
    <!--loading蒙版-->
    <div v-show="visible" class="custom-loading-mask">
      <!--loading中间的图标-->
      <div class="custom-loading-spinner">
        <a-icon type="loading" class="custom-loading" />
        <!--loading上面显示的文字-->
        <p class="custom-loading-text">{{ text }}</p>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  data() {
    return {
      text: "",
      visible: false
    };
  }
};
</script>
<style scoped>
.custom-loading-mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.custom-loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.custom-loading {
  font-size: 36px;
  margin-bottom: 10px;
  color: #1890ff;
}

.custom-loading-text {
  color: #1890ff;
}
</style>



// WEBPACK FOOTER //
// src/components/Loading/loading.vue